<div class="row" *ngIf="isPaymentRequestsAmountWrong">
    <div class="col-12">
        <span class="text-danger">{{paymentWrongTotalAmountErrorMessage}}</span>
    </div>
</div>
<div class="row">
    <app-form-field [required]="true" label="Type" [size]="12" [sizeXl]="12" [sizeLg]="12">
        <app-select
                [elements]="paymentTypeSelectElements"
                [parentFormGroup]="parentFormGroup.get(parentFormControlName)" parentFormControlName="type">
        </app-select>
    </app-form-field>
</div>
<div class="row">
    <div class="col-12">
        <app-form-array-input
                [buildNewItemForm]="newPaymentRequestFromArrayForm"
                [parentFormGroup]="parentFormGroup.get(parentFormControlName)"
                (itemAddedEvent)="refreshPossibleAccountTypes($event)"
                addItemLabel="Ajouter"
                parentFormControlName="paymentRequests">
            <ng-template let-itemFormGroup='itemFormGroup' template-content>
                <div class="row">
                    <div class="col-12">
                        {{itemFormGroup.controls.label.value}}
                    </div>
                </div>
                <div class="row">
                    <app-form-field [required]="true" label="Montant" size="12" sizeLg="2" sizeXl="2">
                        <app-amount-input [parentFormGroup]="itemFormGroup"
                                          parentFormControlName="amount"
                                          (valueChangedEvent)="onTotalAmountRequestedChanged()"
                                          unit="€"></app-amount-input>
                    </app-form-field>
                    <app-form-field label="Date limite de paiement" size="12" sizeLg="2" sizeXl="2">
                        <app-date-picker [parentFormGroup]="itemFormGroup"
                                         parentFormControlName="deadline">
                        </app-date-picker>
                    </app-form-field>
                    <app-form-field [required]="true" label="Déléguer le paiement" sizeXl="1" sizeLg="1">
                        <mat-radio-group (change)="thirdPartyPaymentTypeChanged(itemFormGroup)" [formControl]="itemFormGroup.get('thirdPartyPaymentType')">
                            <mat-radio-button value="none">Non</mat-radio-button>
                            <mat-radio-button [value]="v.value" *ngFor="let v of availableThirdPaymentTypes">{{v.label}}
                                <ng-container *ngIf="v.partnerSummary">
                                    ({{v.partnerSummary.name}})
                                </ng-container>
                            </mat-radio-button>
                        </mat-radio-group>

                        <!--<app-checkbox-input parentFormControlName="thirdPartyPayment" [parentFormGroup]="itemFormGroup"></app-checkbox-input>-->
                    </app-form-field>
                    <app-form-field sizeXl="1" sizeLg="1"
                                    [label]="directionValue === DIRECTION_IN ? 'Déjà payé' : 'Encaisser maintenant'">
                        <app-checkbox-input
                                (changeEvent)="paymentRequestCollectChanged($event, itemFormGroup)"
                                [parentFormGroup]="itemFormGroup"
                                parentFormControlName="collect">
                        </app-checkbox-input>
                    </app-form-field>
                    <ng-container *ngIf="itemFormGroup.get('accountingMovement')">
                        <app-form-field [required]="true" label="Date" size="12" sizeLg="2" sizeXl="2">
                            <app-date-picker [parentFormGroup]="itemFormGroup.get('accountingMovement')"
                                             parentFormControlName="date"></app-date-picker>
                        </app-form-field>
                        <app-form-field [required]="true" label="Moyen de paiement" size="12" sizeLg="2" sizeXl="2">
                            <app-payment-type-select-filter
                                    [movementType]="directionValue === DIRECTION_IN ? MovementType.EXPENDITURE : MovementType.REVENUE"
                                    [parentFormGroup]="itemFormGroup.get('accountingMovement')"
                                    parentFormControlName="paymentTypeValue"
                                    (_onSingleSelectionChange)="paymentTypeChanged($event, itemFormGroup)">
                            </app-payment-type-select-filter>
                        </app-form-field>
                        <ng-container *ngIf="itemFormGroup.get('accountingMovement').get('check')">
                            <app-form-field label="Numéro du chèque" size="12" sizeLg="2" sizeXl="2">
                                <app-input-text [parentFormGroup]="itemFormGroup.get('accountingMovement').get('check')" parentFormControlName="number"></app-input-text>
                            </app-form-field>
                            <app-form-field label="Emetteur du chèque" size="12" sizeLg="2" sizeXl="2">
                                <app-input-text [parentFormGroup]="itemFormGroup.get('accountingMovement').get('check')" parentFormControlName="from"></app-input-text>
                            </app-form-field>
                            <app-form-field label="Banque de l'émetteur">
                                <app-lov-value-select-filter lovListName="FINANCIAL_BANK" [parentFormGroup]="itemFormGroup.get('accountingMovement').get('check')" parentFormControlName="bankValue"></app-lov-value-select-filter>
                            </app-form-field>
                        </ng-container>
                        <app-form-field [required]="true" label="Compte" size="12" sizeLg="2" sizeXl="2">
                            <app-accounting-account-select-filter (_onSingleSelectionChange)="accountChanged($event)"
                                                                  [parentFormGroup]="itemFormGroup.get('accountingMovement')"
                                                                  [typeValue]="itemFormGroup.get('possibleAccountType').value"
                                                                  parentFormControlName="accountId"
                                                                (elementsChangeEvent)="selectDefaultAccount(itemFormGroup.get('accountingMovement'), $event)"></app-accounting-account-select-filter>
                        </app-form-field>
                    </ng-container>
                    <app-form-field sizeXl="1" sizeLg="1" label="Générer une communication" *ngIf="itemFormGroup.get('generateCommunication')">
                        <app-checkbox-input
                                [parentFormGroup]="itemFormGroup"
                                parentFormControlName="generateCommunication">
                        </app-checkbox-input>
                    </app-form-field>
                </div>
            </ng-template>
        </app-form-array-input>
    </div>
</div>

